import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import COLOR_MAP from '../../../../constants/color-mapping';
import PopoverInfoIcon from '../../../../components/PopoverInfoIcon/PopoverInfoIcon';
import InfoUnavailable from '../../../../components/common/InfoUnavailable';

const SideEffects = forwardRef(function ({ sideEffects }, ref) {
  return (
    <div ref={ref} className="mb-36 scroll-offset" id="side-effects-section">
      <h4>Side Effects</h4>
      {sideEffects?.Side_Effects?.length ? (
        <div className="ps-table table-responsive mb-4 mt-3">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">SIDE EFFECT</th>
                <th scope="col">FREQUENCY</th>
                <th scope="col">
                  SEVERITY DESCRIPTION
                  <PopoverInfoIcon popoverInfo={COLOR_MAP.SideEffects} />
                </th>
              </tr>
            </thead>
            <tbody>
              {sideEffects.Side_Effects.sort(
                (a, b) => Number(b.Severity) - Number(a.Severity),
              ).map((effect, index) => (
                <tr key={`side-effect-${index}`}>
                  <td className="text-capitalize">{effect.ConditionDesc}</td>
                  <td>{effect.FrequencyOfOccurrenceCodeDesc}</td>
                  <td>
                    <span
                      className={COLOR_MAP.SideEffects[effect.SeverityDesc]}
                    />
                    {effect.SeverityDesc}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <InfoUnavailable />
      )}
    </div>
  );
});

SideEffects.propTypes = {
  sideEffects: PropTypes.object.isRequired,
};

SideEffects.displayName = 'SideEffects';

export default SideEffects;
